const GLOBAL_KEY = '__VANCE_WS__';
function read() {
    return globalThis[GLOBAL_KEY] ?? null;
}
function write(value) {
    globalThis[GLOBAL_KEY] = value;
}
/**
 * Bind the host's WebSocket-store implementation. Must be called once at
 * boot, BEFORE any addon-registration that touches subscriptions —
 * otherwise an addon's first {@link getVanceWs} call throws.
 *
 * <p>Idempotent / replaceable — the most recent configuration wins.
 * There is no listener mechanism; callers re-resolve via {@link getVanceWs}
 * on each access rather than caching.
 */
export function configureVanceWs(impl) {
    write(impl);
}
/**
 * Resolve the host-provided WebSocket API. Throws when
 * {@link configureVanceWs} has not been called — there's no default
 * (the WS singleton lives in the host bundle, not here).
 */
export function getVanceWs() {
    const api = read();
    if (api === null) {
        throw new Error('@vance/shared: WS API not configured — call configureVanceWs({...}) '
            + 'at app startup before any consumer subscribes.');
    }
    return api;
}
/**
 * Test-only: forget the current bindings. Mirrors {@code __resetPlatform}.
 */
export function __resetVanceWs() {
    write(null);
}
//# sourceMappingURL=bridge.js.map